import { render, staticRenderFns } from "./teamDetail.vue?vue&type=template&id=e1fd0204&scoped=true"
import script from "./teamDetail.vue?vue&type=script&lang=js"
export * from "./teamDetail.vue?vue&type=script&lang=js"
import style0 from "./teamDetail.vue?vue&type=style&index=0&id=e1fd0204&prod&scoped=true&lang=css"
import style1 from "./teamDetail.vue?vue&type=style&index=1&id=e1fd0204&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fd0204",
  null
  
)

export default component.exports